import {getDataWithPromise, Globals } from "../globals";
import { handleAjaxError} from './ErrorHandlingFunctions'
import { getParamList } from "./BaseDataFns";

export const getChildDataWithDetails = ( enc_child_id, flagArray, onComplete ) =>
{
    const url = Globals.APIFolder + '/eyfsn/school/any/user/' + enc_child_id + '/details' ;

    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const getChildGoogleAccessLevel = (user_account_id) =>
{
    const url = Globals.APIFolder + '/users/' + user_account_id + '/googledetails';

    return getDataWithPromise(url, 'GET', {});
}

export const getThemesForPupilHome = () =>
{
    const url = Globals.APIFolder + '/themes';

    return getDataWithPromise(url, 'GET', {});
}

